import { App } from 'vue'
import vSizeDirective from './src/size.ts'

export default {
	install: (app: App) => {
		app.directive('size', vSizeDirective)
	},
}

export { vSizeDirective as vSize }
